module.exports = __webpack_public_path__ + "img/dark_cabin_bag.bbc75be2.png";